"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const plc_1 = require("../../../plc");
const plcInput_1 = require("../plcInput");
let PlcRadioComponent = class PlcRadioComponent extends plcInput_1.PlcInput {
    constructor(inaxPlc, _ref) {
        super(inaxPlc);
        this._ref = _ref;
        this.successRadioClass = 'basicblue'; // static, can be modified here to alter design of active radio
        /* SPECIFIC INPUTS */
        this.values = [];
    }
    get Value() {
        return this._value;
    }
    set Value(v) {
    }
    ngOnInit() {
        this.initializeDefaultProperties();
        this.initialize();
        this.subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    initialize() {
        // console.log(this.values);
    }
    /**
     * updates the current value
     */
    updateValue(value) {
        this._value = value;
    }
    /**
     * handles a click on a radio-button by the user
     * - tries to write the value specified by the radio-button clicked
     * - if the write-operation completes successfully, the DataChangeEvent will update the value
     * - on a fail, the previous value is re-set
     * the ChangeDetector is called in between to ensure the updating of the UI, so
     * the radio will always display the correct value
     */
    radioChangeHandler(val) {
        let temp = this._value;
        // force change detection
        this.updateValue('');
        this._ref.detectChanges();
        if (this.write(val) !== true) {
            // if writing is unsuccessful (e.g. no permission, set old value and trigger change detection to update UI)
            this.updateValue(temp);
            this._ref.detectChanges();
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], PlcRadioComponent.prototype, "values", void 0);
PlcRadioComponent = __decorate([
    core_1.Component(Object.assign({
        selector: 'plc-radio',
        templateUrl: './@inax/plcUi/src/plcRadio/plc-radio.component.html',
        styleUrls: ['./@inax/plcUi/src/plcRadio/plc-radio.component.css']
    }, plcInput_1.PlcInput.metaData)),
    __metadata("design:paramtypes", [plc_1.InaxPlcService, core_1.ChangeDetectorRef])
], PlcRadioComponent);
exports.PlcRadioComponent = PlcRadioComponent;
